export default {
    'multiple-languages': {
        title: 'Version 2.3: Keybreak Speaks Seven Languages',
        excerpt: 'Version 2.3 brings multi-language support: the whole app and website are now available in seven languages, with more on the way.',
    },
    'micro-breaks': {
        title: 'Version 2.2: Micro Breaks',
        excerpt: 'After some user feedback, version 2.2 adds micro breaks: a small prompt in the corner of your screen every 10–15 minutes with one thing to try.',
    },
    'dynamic-hold-system': {
        title: 'Version 2.1: Smarter Holds and Better Feedback',
        excerpt: 'Version 2.1 adds two things: a way to increase hold time on the fly, and a new animation system that shows you exactly where you are in each hold.',
    },
    'science-of-sitting': {
        title: 'The Science of Sedentary Behaviour: What Research Tells Us About Sitting All Day',
        excerpt: "Sedentary behaviour is a distinct health risk, largely independent of whether you exercise. Here's what the research actually shows.",
    },
    'benefits-of-moving': {
        title: 'Why Moving More During Your Workday Actually Matters',
        excerpt: "Regular movement breaks don't just help your body. They make you sharper, less fatigued, and more productive over the course of a day.",
    },
    'keybreak-launch': {
        title: 'Keybreak: Meet Your Smart Break Companion',
        excerpt: "After months of development, we're thrilled to announce that Keybreak is officially available, free to download for Mac and Windows.",
    },
}
